import { formatCurrency } from '@angular/common';

import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import {ButtonData} from '../mapping-classes/button-data';

export class Idealprofile implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = '';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = 'iDEAL Profiel';
      this.actualityDateTime = response.detailsViewObject.profileCreationTime;
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues(response);
      this.addValues(response);
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues(response?) {
    const cards = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillProductDetailsPanel(productDetailsPanel);

    const cardsPanel: DetailPanel = this.panels[1];

    if (cards.consents && cards.consents.length) {
      this.addSubHeaderToPanel(cardsPanel, 'Overzicht toestemming rekeningen');
    }
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);

    if (obj.consents) {
      const cardsPanel: DetailPanel = this.panels[1];
      this.addValuesToCardsPanel(cardsPanel, obj);
    }
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('cit', new DetailLabel('Profielnummer (CIT)'));
    productDetailsPanel.nameAndValues.set('citState', new DetailLabel('Profielstatus'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('cit').setValue(obj.cit || '-');
    productDetailsPanel.nameAndValues.get('citState').setValue(obj.citState || '-');
  }

  private addValuesToCardsPanel(cardsPanel: DetailPanel, obj) {
    if (obj.consents) {
      this.addTable(cardsPanel, obj, 'idealprofilecards', 0);
    }
  }

  private addTable(panel: DetailPanel, obj, table, index) {

    // tslint:disable-next-line:no-shadowed-variable
    const tables = ( table ): string => {
      const tablesType = {
        idealprofilecards: 'consents',
      };

      return tablesType[table];
    };

    panel.subPanels[index].hasTable = true;
    panel.subPanels[index].lazyLoadingData =
      new LazyLoadingData(null, null, table);

    if (obj[tables(table)] && obj[tables(table)].length !== 0) {
      obj[tables(table)].forEach((_table) => {
        _table.restrictedData = obj.restrictedData;
      });
      panel.subPanels[index].lazyLoadingData.data = obj[tables(table)];
    }
  }
}
